import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_6a8771b6 from 'nuxt_plugin_plugin_6a8771b6' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_sentryserver_cf0bd302 from 'nuxt_plugin_sentryserver_cf0bd302' // Source: ./sentry.server.js (mode: 'server')
import nuxt_plugin_sentryclient_32c0a4f7 from 'nuxt_plugin_sentryclient_32c0a4f7' // Source: ./sentry.client.js (mode: 'client')
import nuxt_plugin_cookieuniversalnuxt_436de93a from 'nuxt_plugin_cookieuniversalnuxt_436de93a' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_pluginutils_17370c40 from 'nuxt_plugin_pluginutils_17370c40' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_232e0f2b from 'nuxt_plugin_pluginrouting_232e0f2b' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_38022424 from 'nuxt_plugin_pluginmain_38022424' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_vlazyload_c0fe332e from 'nuxt_plugin_vlazyload_c0fe332e' // Source: ./v-lazy-load.js (mode: 'all')
import nuxt_plugin_axios_d8477c8a from 'nuxt_plugin_axios_d8477c8a' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_fontawesome_444a9cbd from 'nuxt_plugin_fontawesome_444a9cbd' // Source: ./fontawesome.js (mode: 'all')
import nuxt_plugin_workbox_e0b997d2 from 'nuxt_plugin_workbox_e0b997d2' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_metaplugin_36ae742a from 'nuxt_plugin_metaplugin_36ae742a' // Source: ./pwa/meta.plugin.js (mode: 'all')
import nuxt_plugin_iconplugin_3b56199e from 'nuxt_plugin_iconplugin_3b56199e' // Source: ./pwa/icon.plugin.js (mode: 'all')
import nuxt_plugin_sentryaccessor_58a8ce88 from 'nuxt_plugin_sentryaccessor_58a8ce88' // Source: ../plugins/accessors/sentry-accessor (mode: 'all')
import nuxt_plugin_i18naccessor_b81019c6 from 'nuxt_plugin_i18naccessor_b81019c6' // Source: ../plugins/accessors/i18n-accessor (mode: 'all')
import nuxt_plugin_twemoji_6cc0a76a from 'nuxt_plugin_twemoji_6cc0a76a' // Source: ../plugins/twemoji.js (mode: 'all')
import nuxt_plugin_notifications_15a88b85 from 'nuxt_plugin_notifications_15a88b85' // Source: ../plugins/notifications.js (mode: 'all')
import nuxt_plugin_vuetour_f3e3d3bc from 'nuxt_plugin_vuetour_f3e3d3bc' // Source: ../plugins/vue-tour.js (mode: 'all')
import nuxt_plugin_tokenInterceptor_5f8aba0b from 'nuxt_plugin_tokenInterceptor_5f8aba0b' // Source: ../plugins/tokenInterceptor.ts (mode: 'all')
import nuxt_plugin_errorInterceptor_0c0a0bda from 'nuxt_plugin_errorInterceptor_0c0a0bda' // Source: ../plugins/errorInterceptor.ts (mode: 'all')
import nuxt_plugin_scrollrevealclient_a4220da4 from 'nuxt_plugin_scrollrevealclient_a4220da4' // Source: ../plugins/scrollreveal.client.js (mode: 'client')
import nuxt_plugin_queue_a4a3fc1c from 'nuxt_plugin_queue_a4a3fc1c' // Source: ../plugins/queue.ts (mode: 'all')
import nuxt_plugin_vuestripeclient_668db870 from 'nuxt_plugin_vuestripeclient_668db870' // Source: ../plugins/vue-stripe.client.js (mode: 'client')
import nuxt_plugin_paymentBlockerclient_80562ec4 from 'nuxt_plugin_paymentBlockerclient_80562ec4' // Source: ../plugins/paymentBlocker.client.ts (mode: 'client')
import nuxt_plugin_libnuxtclientinitpluginclient62f012f4_6fbac392 from 'nuxt_plugin_libnuxtclientinitpluginclient62f012f4_6fbac392' // Source: ./lib.nuxt-client-init.plugin.client.62f012f4.js (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"meta":[{"hid":"og:image","property":"og:image","content":"https:\u002F\u002Fcdn.plan-your-van.com\u002Fshare.png"},{"hid":"og:description","property":"og:description","content":"3D DIY Camper Van Planungstool. Einfach zu bedienen für Vanausbau Anfänger und Fortgeschrittene."},{"hid":"og:url","property":"og:url","content":"https:\u002F\u002Fplan-your-van.com"},{"hid":"og:type","property":"og:type","content":"website"},{"hid":"twitter:card","property":"twitter:card","content":"summary_large_image"},{"hid":"twitter:site","property":"twitter:site","content":"@danielvonmirbach"},{"hid":"twitter:creator","property":"twitter:creator","content":"@danielvonmirbach"},{"hid":"twitter:url","property":"twitter:url","content":"https:\u002F\u002Fplan-your-van.com"},{"hid":"twitter:title","property":"twitter:title","content":"Plan your Van | 3D Vanplanung"},{"hid":"twitter:description","property":"twitter:description","content":"3D DIY Camper Van Planungstool. Einfach zu bedienen für Vanausbau Anfänger und Fortgeschrittene."},{"hid":"twitter:image","property":"twitter:image","content":"https:\u002F\u002Fcdn.plan-your-van.com\u002Fshare.png"}],"link":[],"style":[],"script":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_6a8771b6 === 'function') {
    await nuxt_plugin_plugin_6a8771b6(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_sentryserver_cf0bd302 === 'function') {
    await nuxt_plugin_sentryserver_cf0bd302(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentryclient_32c0a4f7 === 'function') {
    await nuxt_plugin_sentryclient_32c0a4f7(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_436de93a === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_436de93a(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_17370c40 === 'function') {
    await nuxt_plugin_pluginutils_17370c40(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_232e0f2b === 'function') {
    await nuxt_plugin_pluginrouting_232e0f2b(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_38022424 === 'function') {
    await nuxt_plugin_pluginmain_38022424(app.context, inject)
  }

  if (typeof nuxt_plugin_vlazyload_c0fe332e === 'function') {
    await nuxt_plugin_vlazyload_c0fe332e(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_d8477c8a === 'function') {
    await nuxt_plugin_axios_d8477c8a(app.context, inject)
  }

  if (typeof nuxt_plugin_fontawesome_444a9cbd === 'function') {
    await nuxt_plugin_fontawesome_444a9cbd(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_workbox_e0b997d2 === 'function') {
    await nuxt_plugin_workbox_e0b997d2(app.context, inject)
  }

  if (typeof nuxt_plugin_metaplugin_36ae742a === 'function') {
    await nuxt_plugin_metaplugin_36ae742a(app.context, inject)
  }

  if (typeof nuxt_plugin_iconplugin_3b56199e === 'function') {
    await nuxt_plugin_iconplugin_3b56199e(app.context, inject)
  }

  if (typeof nuxt_plugin_sentryaccessor_58a8ce88 === 'function') {
    await nuxt_plugin_sentryaccessor_58a8ce88(app.context, inject)
  }

  if (typeof nuxt_plugin_i18naccessor_b81019c6 === 'function') {
    await nuxt_plugin_i18naccessor_b81019c6(app.context, inject)
  }

  if (typeof nuxt_plugin_twemoji_6cc0a76a === 'function') {
    await nuxt_plugin_twemoji_6cc0a76a(app.context, inject)
  }

  if (typeof nuxt_plugin_notifications_15a88b85 === 'function') {
    await nuxt_plugin_notifications_15a88b85(app.context, inject)
  }

  if (typeof nuxt_plugin_vuetour_f3e3d3bc === 'function') {
    await nuxt_plugin_vuetour_f3e3d3bc(app.context, inject)
  }

  if (typeof nuxt_plugin_tokenInterceptor_5f8aba0b === 'function') {
    await nuxt_plugin_tokenInterceptor_5f8aba0b(app.context, inject)
  }

  if (typeof nuxt_plugin_errorInterceptor_0c0a0bda === 'function') {
    await nuxt_plugin_errorInterceptor_0c0a0bda(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_scrollrevealclient_a4220da4 === 'function') {
    await nuxt_plugin_scrollrevealclient_a4220da4(app.context, inject)
  }

  if (typeof nuxt_plugin_queue_a4a3fc1c === 'function') {
    await nuxt_plugin_queue_a4a3fc1c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuestripeclient_668db870 === 'function') {
    await nuxt_plugin_vuestripeclient_668db870(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_paymentBlockerclient_80562ec4 === 'function') {
    await nuxt_plugin_paymentBlockerclient_80562ec4(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_libnuxtclientinitpluginclient62f012f4_6fbac392 === 'function') {
    await nuxt_plugin_libnuxtclientinitpluginclient62f012f4_6fbac392(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
